import { AssetUrls } from 'config/assets';
import './CardsTableEmptyPlaceholder.css';

export const CardsTableEmptyPlaceholder = () => {
  return (
    <div className="cards-table-empty-placeholder">
      <img
        src={AssetUrls.logos.arevakhachIcon}
        alt="send-icon"
        style={{ width: 45, height: 45 }}
      />
      <div className="cards-table-empty-placeholder-title">
        Nothing to see here yet...
      </div>
      <div className="cards-table-empty-placeholder-message">
        Try adding some cards to this list.
      </div>
    </div>
  );
};
